import _Object$assign from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/object/assign';
import _Set from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/set';
import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _getIterator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/core-js/get-iterator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import componentRelatedUser from '~/components/related-user.vue';
import componentRelatedFile from '~/components/related-document.vue';
import modal from '~/components/modal.vue';
import grantchart from '~/components/grantchart.vue';
import grantchartQU from '~/components/grantchartQU.vue';
import tab from '~/components/tab/tab.vue';
import tabs from '~/components/tab/tabs.vue';
import chat from '~/components/chat.vue';
import API from '~/api/api.js';
import socket from '~/plugins/socket.io.js';
import prodDetail from '~/components/project-detail.vue';
import isButton from '~/components/button.vue';
import chatFull from '~/components/chat-full-box.vue';
// import { isAdminCheck } from '~/lib/authen'
var miniToastr = void 0;
var Datepicker = void 0;
if (process.browser) {
  miniToastr = require('mini-toastr');
  Datepicker = require('vuejs-datepicker');
}
var userData = '';
export default {
  middleware: ['auth', 'authorizeAdminAndEngineer'],
  mounted: function mounted() {
    miniToastr.init();
  },

  notifications: {
    showLoginError: {
      title: 'Error',
      message: 'Hello from nuxt.js',
      type: 'error'
    },
    showSuccess: {
      title: 'Success',
      message: '',
      type: 'success'
    }
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          params = _ref.params,
          error = _ref.error;

      var l, value1, prodTask, messageResponse, messages, detail, finalTaskList, listEngineer, listQU, lastQU, valueLast, valueQU, valueEn, teamMember, personData, personInChat, engineerObj, allTaskRaw, groupVendor, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, task;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              l = store.state.authUser;

              userData = l;
              _context.next = 4;
              return API.setToken(userData.tokenID);

            case 4:
              _context.next = 6;
              return API.getProject(params.id);

            case 6:
              value1 = _context.sent;

              if (!(value1.status !== 200)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt('return', error({ statusCode: value1.status, message: value1.message }));

            case 9:
              if (!(value1.data.flag === false)) {
                _context.next = 11;
                break;
              }

              return _context.abrupt('return', error({ statusCode: 401, message: value1.data.message }));

            case 11:
              _context.next = 13;
              return API.listTaskOfProject(params.id);

            case 13:
              prodTask = _context.sent;
              _context.next = 16;
              return API.getMessage(params.id);

            case 16:
              messageResponse = _context.sent;
              messages = messageResponse.data.datas;
              detail = value1.data.datas;
              finalTaskList = [];
              listEngineer = [];
              listQU = [];
              lastQU = null;
              // let lastQU = []

              _context.next = 25;
              return API.GetLastQU(params.id);

            case 25:
              valueLast = _context.sent;


              lastQU = valueLast.data.datas;
              _context.next = 29;
              return API.GetQUOfProject(params.id);

            case 29:
              valueQU = _context.sent;

              listQU = valueQU.data.datas;

              _context.next = 33;
              return API.GetEngineerOfProject(params.id);

            case 33:
              valueEn = _context.sent;


              // let teamMemberDev = valueEn.data.datas.map(task => task.id + 'test')
              teamMember = valueEn.data.datas.map(function (item) {
                if (item.id === detail.ownerID) {
                  item.isOwner = true;
                } else {
                  item.isOwner = false;
                }
                return item;
              });
              _context.next = 37;
              return API.getPersonInProject(params.id);

            case 37:
              personData = _context.sent;
              personInChat = personData.data.datas;

              if (!(userData.roleID === 'User' || userData.roleID === 'SuperAdmin')) {
                _context.next = 45;
                break;
              }

              finalTaskList = [];
              _context.next = 43;
              return API.showPersonAssign();

            case 43:
              engineerObj = _context.sent;

              listEngineer = engineerObj.data.datas;

            case 45:
              _context.next = 47;
              return socket.emit('register-room', params.id);

            case 47:
              allTaskRaw = prodTask.data.datas;
              groupVendor = [];

              _loop = function _loop(task) {
                var find = groupVendor.filter(function (o) {
                  return o.vendorID === task.vendorID;
                });
                if (find === null || find.length === 0) {
                  groupVendor.push({
                    vendorID: task.vendorID,
                    vendorName: task.vendorName,
                    tasks: [task]
                  });
                } else {
                  find[0].tasks.push(task);
                }
              };

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 53;


              for (_iterator = _getIterator(allTaskRaw); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                task = _step.value;

                _loop(task);
              }
              _context.next = 61;
              break;

            case 57:
              _context.prev = 57;
              _context.t0 = _context['catch'](53);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 61:
              _context.prev = 61;
              _context.prev = 62;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 64:
              _context.prev = 64;

              if (!_didIteratorError) {
                _context.next = 67;
                break;
              }

              throw _iteratorError;

            case 67:
              return _context.finish(64);

            case 68:
              return _context.finish(61);

            case 69:
              return _context.abrupt('return', {
                ProjectDetail: detail,
                completeInfo: { invoiceNo: '', invoiceDate: '' },
                groupVendor: groupVendor,
                ProductionTask: prodTask.data.datas,
                task: prodTask.data.datas,
                finalTask: finalTaskList,

                projectID: params.id,
                projectFiles: detail.pro_attach_files,
                time: new Date(),
                userData: userData,
                messages: messages,
                message: '',
                engineer: listEngineer,
                listQU: listQU,
                lastQU: lastQU,
                personInChat: personInChat,
                allPersonInProject: teamMember,
                listEngOfProject: valueEn.data.datas.filter(function (o) {
                  return o.role === 'Engineer' || o.role === 'User' || o.role === 'SuperAdmin';
                }),
                remind: {
                  remind: '',
                  remindDate: ''
                },
                allTask: [],

                DeleteMessage: ''
              });

            case 70:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[53, 57, 61, 69], [62,, 64, 68]]);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {
      updateRemark: '',
      jobNumber: '',
      currentTaskID: null,
      openAcceptProject: false,
      openActKnowledge: false,
      openAssignJob: false,

      openReminder: false,
      openEngineer: false,
      openDelete: false,
      openSetAct: false,
      openComplete: false,
      ProjectDetail: null,
      openResetQuotation: false,
      openAcceptQuotation: false,
      openAcceptTask: false,
      openCancelTask: false,
      openCancel: false,
      quAccept: {
        quNo: '',
        revise: ''
      },
      counter: 0,
      engineer: '',
      searchText: '',
      filterEngineer: '',
      statusDatas: ['New', 'Quoting', 'Quoted', 'Working', 'Complete'],
      indexStatus: 0
    };
  },

  computed: {
    engineerFilter: function engineerFilter() {
      var ids = new _Set();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = _getIterator(this.listEngOfProject), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var en = _step2.value;

          ids.add(en.id);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.filterEngineer = this.engineer.filter(function (o) {
        return !ids.has(o.id);
      });
    }
  },
  methods: {
    isViewFile: function isViewFile() {
      // console.log(this.$store.state.authUser.roleID)
      if (['User', 'SuperAdmin', 'Engineer'].includes(this.$store.state.authUser.roleID)) {
        return true;
      }
      return false;
    },
    isAdmin: function isAdmin() {
      // console.log(this.$store.state.authUser.roleID)
      if (['User', 'SuperAdmin'].includes(this.$store.state.authUser.roleID)) {
        return true;
      }
      return false;
    },
    isAdminData: function isAdminData(roleID) {
      roleID = roleID.toLowerCase();
      if (['User', 'SuperAdmin'].includes(roleID)) {
        return true;
      }
      return false;
    },
    canOpenTask: function canOpenTask(projectStatus) {
      if (projectStatus === 'New' && this.$store.state.authUser.roleID === 'SuperAdmin') {
        return true;
      }
      if (projectStatus === 'Quoting' && this.isAdmin()) {
        return true;
      }
      return false;
    },
    showAcceptQU: function showAcceptQU(quNo, revise) {
      this.openAcceptQuotation = true;
      this.quAccept.quNo = quNo;
      this.quAccept.revise = revise;
    },
    getProjectStatusDate: function getProjectStatusDate(item) {
      if (item === 'New') {
        return this.ProjectDetail.createOn;
      }
      if (item === 'Quoting') {
        return this.ProjectDetail.quotingDate;
      }
      if (item === 'Quoted') {
        return this.ProjectDetail.quotedDate;
      }
      if (item === 'Working') {
        return this.ProjectDetail.workingDate;
      }
      if (item === 'Delete') {
        return this.ProjectDetail.deleteDate;
      }
      if (item === 'Complete') {
        return this.ProjectDetail.completeDate;
      }
      return item;
    },
    confirmAcceptQuotation: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context2.next = 4;
                return API.AcceptQU(this.quAccept.quNo, this.quAccept.revise);

              case 4:
                result = _context2.sent;

                if (result !== undefined) {
                  if (result.data.flag) {
                    this.showSuccess({ message: 'Already accept QU' });
                    window.location.reload();
                  } else {
                    this.$refs.btnAcceptQuotation.enabled();
                    this.showLoginError({ message: result.data.message });
                  }
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function confirmAcceptQuotation() {
        return _ref3.apply(this, arguments);
      }

      return confirmAcceptQuotation;
    }(),
    deleteProject: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                if (!(this.DeleteMessage === '')) {
                  _context3.next = 6;
                  break;
                }

                this.showLoginError({
                  message: 'Please insert remark for cancel this project'
                });
                this.$refs.btnDelete.enabled();
                return _context3.abrupt('return');

              case 6:
                _context3.next = 8;
                return API.DeleteProject(this.projectID, this.DeleteMessage);

              case 8:
                result = _context3.sent;

                if (result.data.flag) {
                  this.showSuccess({
                    message: 'Already Delete Project'
                  });
                  window.location.reload();
                } else {
                  this.showLoginError({
                    message: result.data.message
                  });
                }

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteProject() {
        return _ref4.apply(this, arguments);
      }

      return deleteProject;
    }(),
    engineerFilter2: function engineerFilter2() {
      var ids = new _Set();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = _getIterator(this.listEngOfProject), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var en = _step3.value;

          ids.add(en.id);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.filterEngineer = this.engineer.filter(function (o) {
        return !ids.has(o.id);
      });
    },
    searchEngineer: function searchEngineer() {
      var _this = this;

      var ids = new _Set();
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = _getIterator(this.listEngOfProject), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var en = _step4.value;

          ids.add(en.id);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var dataForSearch = this.engineer.filter(function (o) {
        return !ids.has(o.id);
      });
      this.filterEngineer = dataForSearch.filter(function (o) {
        return o.firstName.toLowerCase().includes(_this.searchText.toLowerCase()) || o.lastName.toLowerCase().includes(_this.searchText.toLowerCase());
      });
    },
    filterIndex: function filterIndex() {
      this.indexStatus = this.statusDatas.indexOf(this.ProjectDetail.projectStatus);
    },
    confirmAssignEn: function confirmAssignEn() {
      this.showEngineers = false;
    },
    acceptTaskAction: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context4.next = 4;
                return API.acceptTaskFromAdmin(this.projectID, this.currentTaskID);

              case 4:
                result = _context4.sent;

                if (result.data.flag) {
                  this.showSuccess({
                    message: 'Already Accept Task'
                  });
                  window.location.reload();
                } else {
                  this.showLoginError({
                    message: result.data.message
                  });
                  this.$refs.btnConfirmTask.enabled();
                }

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function acceptTaskAction() {
        return _ref5.apply(this, arguments);
      }

      return acceptTaskAction;
    }(),
    activeBullet: function activeBullet(index) {
      if (index <= this.indexStatus) {
        return 'active';
      }
    },
    createlblSpecial: function createlblSpecial(status, index) {
      if (index > this.indexStatus) {
        return 'is-lbl is-status-DeActive special';
      }
      return 'is-lbl is-status-' + status + ' special';
    },

    createlblStep: function createlblStep(status, index) {
      if (index > this.indexStatus) {
        return 'is-lbl is-status-DeActive';
      }
      return 'is-lbl is-status-' + status;
    },
    openAcceptTaskModal: function openAcceptTaskModal(taskID, event) {
      if (event) event.preventDefault();
      this.currentTaskID = taskID;
      this.openAcceptTask = true;
    },
    openCancelTaskModal: function openCancelTaskModal(taskID, event) {
      if (event) event.preventDefault();
      this.currentTaskID = taskID;
      this.openCancelTask = true;
    },
    addEng: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(index) {
        var obj, data, newObj, result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                obj = this.filterEngineer[index];
                data = {
                  id: obj.id,
                  firstName: obj.firstName,
                  lastName: obj.lastName,
                  avatar: obj.avatar,
                  role: obj.role,
                  isOwner: false
                };


                this.listEngOfProject.push(data);

                newObj = {
                  projectID: this.projectID,
                  users: this.listEngOfProject
                };
                _context5.next = 6;
                return API.setToken(this.userData.tokenID);

              case 6:
                _context5.next = 8;
                return API.AssignEngineer(newObj);

              case 8:
                result = _context5.sent;

                if (result.data.flag) {
                  this.allPersonInProject.push(data);
                  this.showSuccess({
                    message: result.data.message
                  });
                  this.engineerFilter2();
                } else {
                  this.showLoginError({
                    message: result.data.message
                  });
                }

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function addEng(_x2) {
        return _ref6.apply(this, arguments);
      }

      return addEng;
    }(),
    removeEng: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(index) {
        var customer, tempAllPerson, newObj, result;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                customer = this.allPersonInProject.filter(function (o) {
                  return o.role === 'Customer';
                });
                tempAllPerson = [];

                tempAllPerson.push(customer[0]);

                this.listEngOfProject.splice(index, 1);
                newObj = {
                  projectID: this.projectID,
                  users: this.listEngOfProject
                };

                this.allPersonInProject = _Object$assign(tempAllPerson, this.listEngOfProject);
                _context6.next = 8;
                return API.setToken(this.userData.tokenID);

              case 8:
                _context6.next = 10;
                return API.AssignEngineer(newObj);

              case 10:
                result = _context6.sent;

                if (result.data.flag) {
                  this.showSuccess({
                    message: result.data.message
                  });
                  this.engineerFilter2();
                } else {
                  this.showLoginError({
                    message: result.data.message
                  });
                }

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function removeEng(_x3) {
        return _ref7.apply(this, arguments);
      }

      return removeEng;
    }(),

    CreateUrlQUDetail: function CreateUrlQUDetail(quNo, revise, projectID) {
      return '/project/quotation/?quNo=' + quNo + '&revise=' + revise + '&projectID=' + projectID;
    },
    showComplete: function showComplete() {
      this.openComplete = true;
    },
    complete: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var result;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context7.next = 4;
                return API.CompleteProject(this.projectID, this.completeInfo);

              case 4:
                result = _context7.sent;

                if (result.data.flag) {
                  this.showSuccess({
                    message: 'Already update project to Complete'
                  });
                  this.$refs.btnComplete.enabled();
                  window.location.reload();
                } else {
                  this.showLoginError({
                    message: result.data.message
                  });
                  this.$refs.btnComplete.enabled();
                }

              case 6:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function complete() {
        return _ref8.apply(this, arguments);
      }

      return complete;
    }(),
    createQUStatus: function createQUStatus(quStatus) {
      return 'lbl lbl-status-' + quStatus;
    },
    acceptQU: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(quNo, revise) {
        var result;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context8.next = 4;
                return API.AcceptQU(quNo, revise);

              case 4:
                result = _context8.sent;


                if (result !== undefined) {
                  if (result.data.flag) {
                    this.showSuccess({
                      message: 'Alredy Accept QU'
                    });
                    window.location.reload();
                  } else {
                    this.showLoginError({
                      message: result.data.message
                    });
                  }
                }

              case 6:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function acceptQU(_x4, _x5) {
        return _ref9.apply(this, arguments);
      }

      return acceptQU;
    }(),
    createUrlRevise: function createUrlRevise(quNo, projectID, revise) {
      return '/project/quotation/create-revise/?quNo=' + quNo + '&projectID=' + projectID + '&revise=' + revise;
    },
    showModelAccept: function showModelAccept() {
      this.openAcceptProject = true;
    },
    showModelConfirm: function showModelConfirm() {
      this.openActKnowledge = true;
    },
    showEngineers: function showEngineers() {
      if (this.openEngineer === true) {
        this.openEngineer = false;
      } else {
        this.openEngineer = true;
      }
    },
    showDelete: function showDelete() {
      this.openDelete = true;
    },
    showCancel: function showCancel() {
      this.openCancel = true;
    },
    showResetQuoation: function showResetQuoation() {
      this.openResetQuotation = true;
    },
    showModalAssign: function showModalAssign() {
      this.openAssignJob = true;
    },
    showModalReminder: function showModalReminder() {
      this.openReminder = true;
    },

    createlbl: function createlbl(status) {
      return 'is-lbl is-status-' + status;
    },
    cancelProject: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var results;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context9.next = 4;
                return API.CancelProject(this.projectID, this.DeleteMessage);

              case 4:
                results = _context9.sent;

                if (results.data.flag) {
                  this.showSuccess({
                    message: 'Reset Quotation'
                  });
                  this.$refs.btnCancel.enabled();
                  window.location.reload();
                } else {
                  this.showLoginError({
                    message: results.data.message
                  });
                  this.$refs.btnCancel.enabled();
                }

                this.openCancel = false;

              case 7:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function cancelProject() {
        return _ref10.apply(this, arguments);
      }

      return cancelProject;
    }(),
    confirmResetQuotation: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var results;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context10.next = 4;
                return API.resetQuotation(this.projectID);

              case 4:
                results = _context10.sent;

                if (results.data.flag) {
                  this.showSuccess({
                    message: 'Reset Quotation'
                  });
                  this.$refs.btnResetQuotation.enabled();
                  window.location.reload();
                } else {
                  this.showLoginError({
                    message: results.data.message
                  });
                  this.$refs.btnResetQuotation.enabled();
                }

                this.openResetQuotation = false;

              case 7:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function confirmResetQuotation() {
        return _ref11.apply(this, arguments);
      }

      return confirmResetQuotation;
    }(),

    acknowledge: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var results;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context11.next = 4;
                return API.acknowledge(this.projectID, {
                  acceptMessage: 'YES'
                });

              case 4:
                results = _context11.sent;

                if (results.data.flag) {
                  this.showSuccess({
                    message: 'Actknowledge this project already'
                  });
                  this.$refs.btnAct.enabled();
                  window.location.reload();
                } else {
                  this.showLoginError({
                    message: results.data.message
                  });
                  this.$refs.btnAct.enabled();
                }

                this.openActKnowledge = false;

              case 7:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function acknowledge() {
        return _ref12.apply(this, arguments);
      }

      return acknowledge;
    }(),
    assignJob: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var results;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                if (!(this.jobNumber === '')) {
                  _context12.next = 5;
                  break;
                }

                this.showLoginError({
                  message: 'Please insert Job Number'
                });
                return _context12.abrupt('return', false);

              case 5:
                _context12.next = 7;
                return API.assignJob(this.projectID, this.jobNumber);

              case 7:
                results = _context12.sent;


                if (results !== undefined) {
                  this.openAssignJob = false;
                  if (results.data.flag) {
                    this.showSuccess({
                      message: 'Already assign job number'
                    });
                    window.location.reload();
                  } else {
                    this.showLoginError({
                      message: results.data.message
                    });
                  }
                }

              case 9:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function assignJob() {
        return _ref13.apply(this, arguments);
      }

      return assignJob;
    }(),
    accept: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var results;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context13.next = 4;
                return API.Accept(this.projectID);

              case 4:
                results = _context13.sent;

                if (results !== undefined) {
                  this.openAssignJob = false;
                  if (results.data.flag) {
                    this.showSuccess({
                      message: 'Accept Project'
                    });
                    window.location.reload();
                  } else {
                    this.showLoginError({
                      message: results.data.message
                    });
                  }
                }

                window.location.reload();

              case 7:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function accept() {
        return _ref14.apply(this, arguments);
      }

      return accept;
    }(),
    createUrlTask: function createUrlTask(id) {
      return '/project/tasks/' + id;
    },
    isCheck: function isCheck(isFinal) {
      if (isFinal === 'Yes') {
        return 'checked';
      }
      return false;
    },
    clickCheckBox: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(obj, event) {
        var prevStatus, results, index;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (event) event.preventDefault();
                prevStatus = obj.isFinal;

                if (obj.isFinal === 'Yes') {
                  obj.isFinal = 'No';
                } else {
                  obj.isFinal = 'Yes';
                }

                _context14.next = 5;
                return API.setToken(this.userData.tokenID);

              case 5:
                _context14.next = 7;
                return API.putTaskToFinal(obj.prodTaskID);

              case 7:
                results = _context14.sent;

                if (results.data.flag) {
                  this.showSuccess({
                    message: results.data.message
                  });
                  if (obj.isFinal === 'Yes') {
                    this.finalTask.push(obj);
                  } else {
                    index = this.finalTask.indexOf(obj);

                    if (index !== -1) {
                      this.finalTask.splice(index, 1);
                    }
                  }
                } else {
                  this.showLoginError({
                    message: results.data.message
                  });
                  obj.isFinal = prevStatus;
                }
                event.stopPropagation();
                return _context14.abrupt('return', false);

              case 11:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function clickCheckBox(_x6, _x7) {
        return _ref15.apply(this, arguments);
      }

      return clickCheckBox;
    }(),
    showActual: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                this.openSetAct = true;

              case 1:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function showActual() {
        return _ref16.apply(this, arguments);
      }

      return showActual;
    }(),
    saveActual: function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var results;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context16.next = 4;
                return API.UpdateActualTask(this.lastQU.quNo, this.lastQU.revise, { actual: this.lastQU.quotationTask, updateRemark: this.updateRemark });

              case 4:
                results = _context16.sent;

                if (results.data.flag) {
                  this.showSuccess({
                    message: 'Save actual date'
                  });
                } else {
                  this.showLoginError({
                    message: results.data.message
                  });
                }
                this.$refs.btnSetActual.enabled();
                window.location.reload();
                this.openSetAct = false;

              case 9:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function saveActual() {
        return _ref17.apply(this, arguments);
      }

      return saveActual;
    }(),
    createUrlQU: function createUrlQU() {
      return '/project/quotation/create/?projectID=' + this.projectID;
    },
    remindProject: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var result;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return API.setToken(this.userData.tokenID);

              case 2:
                _context17.next = 4;
                return API.setRemindProject(this.projectID, this.remind);

              case 4:
                result = _context17.sent;

                if (result.data.flag) {
                  this.showSuccess({
                    message: 'Set remind project already'
                  });
                  this.$refs.btnRemind.enabled();
                } else {
                  this.showLoginError({
                    message: result.data.message
                  });
                  this.$refs.btnRemind.enabled();
                }
                this.openReminder = false;

              case 7:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function remindProject() {
        return _ref18.apply(this, arguments);
      }

      return remindProject;
    }()
  },
  components: {
    componentRelatedUser: componentRelatedUser,
    componentRelatedFile: componentRelatedFile,
    tabs: tabs,
    tab: tab,
    chat: chat,
    modal: modal,
    grantchart: grantchart,
    Datepicker: Datepicker,
    grantchartQU: grantchartQU,
    prodDetail: prodDetail,
    isButton: isButton,
    chatFull: chatFull,
    socket: socket
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/_id.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/_id.vue
// module chunks = 0